import { Controller } from "@hotwired/stimulus";

// 一键复制:备料页把标题/正文/话题/链接一段段复制去平台后台粘贴。
// 用法:<div data-controller="copy-text"><textarea data-copy-text-target="source">…</textarea>
//        <button data-action="copy-text#copy">复制</button></div>
export default class extends Controller {
  static targets = ["source"];

  async copy(event) {
    event.preventDefault();
    const button = event.currentTarget;

    try {
      await navigator.clipboard.writeText(this.sourceTarget.value);
      const original = button.textContent;
      button.textContent = "已复制 ✓";
      setTimeout(() => {
        button.textContent = original;
      }, 1500);
    } catch (err) {
      // 剪贴板要 HTTPS 或 localhost;拿不到就把文本选中,让人手动 Cmd+C
      console.error("复制失败:", err);
      this.sourceTarget.select();
    }
  }
}
